import * as React from 'react';
import { AbstractApplyNowButton, ApplyButtonProps } from './AbstractApplyNowButton';
import { ShowIcon } from './ShowIcon';

export interface ApplyNowButtonProps extends ApplyButtonProps {
    showIcon?: ShowIcon
}

/**
 * Button to apply to all the selected Job Vacancies
 */
export class ApplyNowButton extends AbstractApplyNowButton<ApplyNowButtonProps> {
    public render() {
        const props = this.props;
        const selectedModels = props.selectedModels;
        const className = this.getClassName(selectedModels);
        const title = this.getTitle(selectedModels);
        const text = this.getText(selectedModels);
        const showIcon = props.showIcon;
        const iconBefore = showIcon === ShowIcon.Left ? <i className="fas fa-paper-plane"/> : null;
        const iconAfter = showIcon === ShowIcon.Right ? <i className="fas fa-paper-plane"/> : null;

        return <button className={className} title={title} onClick={this.handleClick}>
            {iconBefore}
            <span>{text}</span>
            {iconAfter}
        </button>;
    }
}
